
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/the-next-chapter",
      function () {
        return require("private-next-pages/blog/the-next-chapter/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/the-next-chapter"])
      });
    }
  